module.exports = __webpack_public_path__ + "static/media/video-poster.64574b0f.jpg";